import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ratio',
  pure: false
})
export class RatioFormatPipe implements PipeTransform {
  transform(value: any): String {
    if (!value) return '';
    if (value == 'N/A') return value;

    const ratios = value.split(':');
    return `${this.roundNum(ratios[0])} : ${this.roundNum(ratios[1])}`;
  }

  roundNum(value) {
    return Math.round(value);
  }
}
